/**
 * @file phone-format.ts
 * @description Единый вид телефона в админке (решение пользователя
 * 2026-09-24, customers.md F17): хранится E.164 (`+79123456789`), печатается
 * `+7 912 345-67-89`. Не-РФ номера — как есть, с пробелом после кода страны
 * не угадываем: у разных стран разная группировка.
 */

/** «+79123456789» → «+7 912 345-67-89»; пустое → «—»; чужое — без изменений. */
export function formatPhone(value: string | null | undefined): string {
  const raw = (value ?? "").trim();
  if (raw === "") return "—";
  const ru = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/u.exec(raw);
  if (ru) return `+7 ${ru[1]} ${ru[2]}-${ru[3]}-${ru[4]}`;
  return raw;
}

/**
 * Черновая нормализация ввода на клиенте: «8 (912) 345-67-89» → «+79123456789».
 * Источник правды — сервер (libphonenumber), здесь только приводим очевидное,
 * чтобы менеджер увидел итоговый вид до сохранения.
 */
export function normalizePhoneInput(value: string): string {
  const digits = value.replace(/\D/gu, "");
  if (digits.length === 11 && (digits.startsWith("8") || digits.startsWith("7"))) {
    return `+7${digits.slice(1)}`;
  }
  if (digits.length === 10 && digits.startsWith("9")) return `+7${digits}`;
  return value.trim().startsWith("+") ? `+${digits}` : value.trim();
}
